import clsx from 'clsx'
import { KTSVG } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { useLayout } from '../../core'
import { useAuthRedux } from "../../../../app/modules/auth"
import { ThemeModeSwitcher } from "../../../../_metronic/partials/layout/theme-mode/ThemeModeSwitcher"
import { useGetBUOptions, useGetBUfromLS } from '../../../../app/hooks/useGetBU'
import { useGlobalContext } from '../../../../app/components/GlobalContext/GlobalContext'
import { ENV_INDICATOR_ENUM } from '../../../../app/common/constants'
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Link } from 'react-router-dom'
import { serviceConfig } from '../../../../app/modules/ServiceRuns/redux/cloudAppAPI'
import { useAppSelector } from '../../../../app/redux/store'
import { useGetServiceConfigQuery } from '../../../../app/modules/ServiceRuns/redux/cloudAppAPI'
import { useEffect } from 'react'

const itemClass = 'ms-1 ms-lg-3'
// const btnClass =
//   'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const Navbar = () => {
  const { config } = useLayout()
  const { fullName, imageURL } = useAuthRedux();
  const { data } = useAppSelector((state) => serviceConfig(state))
  const { bu, setBU, setLoaderMessage, setChatNSRVisible, chatNSRVisible, setChatNSRSettings } = useGlobalContext();
  useGetServiceConfigQuery({}, {
    skip: false
  })
  const buOptions = useGetBUOptions();
  useGetBUfromLS();

  useEffect(() => {
    if (!data) {
      setLoaderMessage("Loading Configuration data...");
      setChatNSRVisible(false);
    } else {
      setLoaderMessage("");
      setChatNSRVisible(data.some(entry => entry.service_descriptive_name === "ChatNSR"));
      const chatNSRSetting = data.find(entry => entry.service_descriptive_name === "ChatNSR")?.chat_app_settings_vars || {};
      setChatNSRSettings(chatNSRSetting ? chatNSRSetting : {});
    } 
  }, [data])

  const handleChange = (event: { target: { value: any } }) => {
    setBU(event.target.value);
    // You can also do any additional actions with the selected option here
  }
  const disabled = bu === "default"

  const getEnvironmentProps = () => {
    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT!

    /** use for mock testing, delete afterwards */
    // const backendEndpoint = "http://127.0.0.1:8000/api/"
    // const backendEndpoint = "https://nsr-latam-dev.coke.com/api/"
    // const backendEndpoint = "https://nsr-ssdp-api-latam-uat.coke.com/api/"
    // const backendEndpoint = "https://nsr-ssdp-api-apac-prod.coke.com/api/"
    /** */

    const envProps: { env?: string; region?: string; } = {};
    envProps.region = backendEndpoint.startsWith("http://") ? "LOCAL" : backendEndpoint.includes("dev") ? "LATAM" : backendEndpoint.split('-')[3].toUpperCase()
    if (backendEndpoint.includes("dev")) {
      envProps.env = "development"
    } else if (backendEndpoint.includes("uat")) {
      envProps.env = "testing"
    } else if (backendEndpoint.includes("prod")) {
      envProps.env = "production"
    } else {
      envProps.env = "localhost"
    }
    return envProps
  }

  return (
    <>
      <div className='app-navbar flex-shrink-0'>
        {(chatNSRVisible &&
          <div className='app-navbar-item ms-1 ms-lg-3'>
            <SmartToyIcon
              onClick={() => window.open(`${window.location.origin}${window.location.pathname}#/chat-nsr`, '_blank')}
              sx={{
                color: "#FFFFFF",
                cursor: "pointer",
                fontSize: "25px",
                '&:hover': {
                  color: "#6ac9ce",
                },
              }}
            />
          </div>
        )}
        <div className="env-indicator" style={{ color: ENV_INDICATOR_ENUM[getEnvironmentProps().env as keyof typeof ENV_INDICATOR_ENUM].color }}>
          {ENV_INDICATOR_ENUM[getEnvironmentProps().env as keyof typeof ENV_INDICATOR_ENUM].short}
        </div>
        <div className='ms-6 py-5 d-flex'>
          <div className='form-select-wrapper'>
            <select className="form-select form-select-solid" value={bu} onChange={handleChange} disabled={disabled}>
              {buOptions && buOptions.map(lbu => (<option key={lbu.value} value={lbu.value}>{lbu.name}</option>))}
            </select>
          </div>
        </div>
        <div className={clsx('app-navbar-item', itemClass)}>
          <ThemeModeSwitcher toggleBtnClass={clsx('btn-active btn-custom')} />
        </div>
        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            {imageURL ? <img alt='User profile' src={imageURL} /> :
              <span className="symbol-label font-size-h5 fw-bold">{fullName ? `${fullName[0]}${fullName.split(" ")[1][0]}` : null}</span>}
          </div>
          <HeaderUserMenu />
        </div>

        {config.app?.header?.default?.menu?.display && (
          <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
            <div
              className='btn btn-icon btn-active-color-primary w-35px h-35px'
              id='kt_app_header_menu_toggle'
            >
              <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
            </div>
          </div>
        )}
      </div>
    </>

  )
}

export { Navbar }
